import { createSlice } from '@reduxjs/toolkit';
import cookie from "react-cookies";

const settingsSlice = createSlice({
	name: 'settings',
	initialState: {
		theme: cookie.load('theme') || 'classic',
		showTraffic: cookie.load('showTraffic') === "1",
		showPokemonLevel: cookie.load('showPokemonLevel') === "1",
		useGps: cookie.load('gps') === "1",
	},
	reducers: {
		setUseGps(state, action) {	state.useGps = action.payload;	},
		setTheme(state, action) {	state.theme = action.payload;	},
		setShowTraffic(state, action) {	state.showTraffic = action.payload;	},
		setShowPokemonLevel(state, action) {	state.showPokemonLevel = action.payload;	},
	}
});

export const { setTheme, setUseGps, setShowTraffic, setShowPokemonLevel } = settingsSlice.actions;

export const chooseTheme = (theme) => {
	return (dispatch, getState) => {
		dispatch(setTheme(theme));

		const date = new Date();
		date.setDate(date.getDate() + 365*10);
		cookie.save('theme', theme, {path: '/', expires: date});
	}
};

export const chooseUseGps = (val) => {
	return (dispatch, getState) => {
		dispatch(setUseGps(val));

		const date = new Date();
		date.setDate(date.getDate() + 365*10);
		cookie.save('gps', val ? 1 : 0, {path: '/', expires: date});
	}
};

export const chooseShowTraffic = (val) => {
	return (dispatch, getState) => {
		dispatch(setShowTraffic(val));

		const date = new Date();
		date.setDate(date.getDate() + 365*10);
		cookie.save('showTraffic', val ? 1 : 0, {path: '/', expires: date});
	}
};

export const chooseShowPokemonLevel = (val) => {
	return (dispatch, getState) => {
		dispatch(setShowPokemonLevel(val));

		const date = new Date();
		date.setDate(date.getDate() + 365*10);
		cookie.save('showPokemonLevel', val ? 1 : 0, {path: '/', expires: date});
	}
};

export default settingsSlice.reducer;